import type { KeyboardEvent } from 'react';

const FOCUSABLE_CONTROLS = [
	'input:not([type="hidden"]):not([disabled])',
	'select:not([disabled])',
	'textarea:not([disabled])',
	'button:not([disabled])',
	'[role="combobox"]:not([disabled])',
	'[role="checkbox"]:not([disabled])',
].join(', ');

/**
 * Focuses the first visible control of the entity form on the page (the form
 * carries `data-entity-form`). Returns false when there is none.
 */
export function focusFirstFormField(): boolean {
	const form = document.querySelector<HTMLElement>('[data-entity-form]');
	if (!form) return false;
	for (const control of form.querySelectorAll<HTMLElement>(FOCUSABLE_CONTROLS)) {
		// display:none controls (e.g. the hidden file input) cannot take focus
		if (control.offsetParent === null) continue;
		control.focus();
		return true;
	}
	return false;
}

/**
 * Tab from a page title input goes straight into the form, skipping the tab
 * strip that sits between them. Shift+Tab keeps its normal behaviour.
 */
export function tabIntoForm(event: KeyboardEvent<HTMLInputElement>) {
	if (event.key !== 'Tab' || event.shiftKey) return;
	if (focusFirstFormField()) event.preventDefault();
}
